import store from "@/store";
import router from "@/router";

export const logout = () => {
  store.commit("SET_TOKEN", { token: null });
  router.push({ name: "Login" });
};
export default logout;
